// Helpers for grouping wallets by activity. Shared between the
// management view (Wallet.js) and the selector view (WalletList.js).

export const INACTIVE_DAYS = 30;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Decide whether a wallet should be shown in the "Tidak aktif" group.
 * Rule: saldo == 0 AND (no last_used OR last_used > INACTIVE_DAYS ago).
 */
export function classifyWallet(w) {
  const sum = Math.round(w.sum || 0);
  if (sum !== 0) return "active";
  if (!w.lastUsed) return "inactive";
  const lastMs = new Date(w.lastUsed).getTime();
  if (Number.isNaN(lastMs)) return "inactive";
  const ageDays = (Date.now() - lastMs) / MS_PER_DAY;
  return ageDays > INACTIVE_DAYS ? "inactive" : "active";
}

/**
 * Merge `useWallet` rows (canonical name + description) with
 * `useWalletAmount` rows (sum + lastUsed) by wallet id.
 */
export function mergeWalletStats(wallets, walletAmounts) {
  const byId = new Map(
    walletAmounts.filter((w) => !w.additional).map((w) => [w.id, w])
  );
  return wallets.map((w) => {
    const stats = byId.get(w.id) || {};
    return {
      ...w,
      sum: stats.sum ?? 0,
      lastUsed: stats.lastUsed ?? null,
    };
  });
}

const MONTHS_ID = [
  "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
  "Jul", "Ags", "Sep", "Okt", "Nov", "Des",
];

/**
 * "Belum pernah dipakai" / "23 Jan 2024" — short label for inactive list.
 */
export function formatRelativeDate(iso) {
  if (!iso) return "Belum pernah dipakai";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "Belum pernah dipakai";
  const dayDiff = Math.floor((Date.now() - d.getTime()) / MS_PER_DAY);
  if (dayDiff < 1) return "Hari ini";
  if (dayDiff < 2) return "Kemarin";
  if (dayDiff < 30) return `${dayDiff} hari lalu`;
  return `${d.getDate()} ${MONTHS_ID[d.getMonth()]} ${d.getFullYear()}`;
}
